import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from "../../../../Common";
import services from "../services";
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { DivisionSummaryReportSchemaObject } from "../DivisionSummaryReportSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from "./createPdf";
import _, { isNumber, round } from "lodash";
import "../../../Common/Table/table.css";
import xlsx from "json-as-xlsx";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import MessageModal from "../../../../UI/Modal/MessageModal";

const screenCode = "DIVISIONSUMMARYREPORT";

export function DivisionSummaryListing(props) {
  const componentRef = useRef();
  const [divisions, setDivisions] = useState([]);
  const [groups, setGroups] = useState([]);
  const [estates, setEstates] = useState([]);
  const [multipleEstates, setMultipleEstates] = useState([]);
  const [fields, setFields] = useState();
  const [divisionSummaryDetails, setDivisionSummaryDetails] = useState({
    groupID: "0",
    estateID: "0",
    divisionID: "0",
    fieldID: "0",
    searchDate: new Date().toISOString().split("T")[0],
    categoryID: "0",
  });

  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupID: "0",
    estateID: "0",
    division: "0",
    field: "0",
    searchDate: "",
    categoryID: "0",
  });

  const [csvData, setCsvData] = useState([]);
  const [errors, setErrors] = useState({});

  const [permissionList, setPermissions] = useState({
    isAddEditEnabled: false,
    isGroupFilterEnabled: false,
    isOperationEntityFilterEnabled: false,
  });
  const schema = Joi.object(DivisionSummaryReportSchemaObject).options({
    allowUnknown: true,
  });

  const contentRowNames = [
    "collectionPointName",
    "fieldName",
    "categoryText",

    // Plucking
    "pluckingOriginalWeight",
    "pluckingRoundDownDeduction",
    "pluckingGrossWeight",
    "pluckingAppliedDeduction",
    "pluckingCheckrollWeight",

    // Field
    "fieldOriginalWeight",
    "fieldRoundDownDeduction",
    "fieldGrossWeight",
    "fieldAppliedDeduction",
    "fieldNetWeight",
    "fieldNoOfBags",

    // Factory
    "recievingFactory",
    "factoryOriginalWeight",
    "factoryRoundDownDeduction",
    "factoryGrossWeight",
    "factoryAppliedDeduction",
    "factoryNetWeight",
    "factoryNoOfBags",
  ];

  const [avialablePluckingDeductions, setAvialablePluckingDeductions] = useState([]);
  let availableDeductionCount = 0;
  let pluckingDeductions = [];
  const [csvHeaders] = useState([
    { label: "Collection Point", value: "collectionPointName" },
    { label: "Field Name", value: "fieldName" },
    { label: "Category", value: "categoryText" },

    { label: "Plucking Round down Deduction", value: "pluckingRoundDownDeduction" },
    { label: "Plucking Gross Weight", value: "pluckingGrossWeight" },
    { label: "Plucking Applied Deduction", value: "pluckingAppliedDeduction" },
    { label: "Plucking Checkroll Weight", value: "pluckingCheckrollWeight" },

    { label: "Field Round down Deduction", value: "fieldRoundDownDeduction" },
    { label: "Field Gross Weight", value: "fieldGrossWeight" },
    { label: "Field Applied Deduction", value: "fieldAppliedDeduction" },
    { label: "Field Net Weight", value: "fieldNetWeight" },
    { label: "Field No Of Bags", value: "fieldNoOfBags" },

    { label: "Recieving Factory", value: "recievingFactory" },
    { label: "Factory Original Weight", value: "factoryOriginalWeight" },
    { label: "Factory Round down Deduction", value: "factoryRoundDownDeduction" },
    { label: "Factory Gross Weight", value: "factoryGrossWeight" },
    { label: "Factory Applied Deduction", value: "factoryAppliedDeduction" },
    { label: "Factory Net Weight", value: "factoryNetWeight" },
    { label: "Factory No Of Bags", value: "factoryNoOfBags" },
  ]);

  const [totalCollections, setTotalCollections] = useState({
    // Plucking
    pluckingOriginalWeight: 0,
    pluckingRoundDownDeduction: 0,
    pluckingGrossWeight: 0,
    pluckingAppliedDeduction: 0,
    pluckingCheckrollWeight: 0,

    // Field
    fieldOriginalWeight: 0,
    fieldRoundDownDeduction: 0,
    fieldGrossWeight: 0,
    fieldAppliedDeduction: 0,
    fieldNetWeight: 0,
    fieldNoOfBags: 0,

    // Factory
    factoryOriginalWeight: 0,
    factoryRoundDownDeduction: 0,
    factoryGrossWeight: 0,
    factoryAppliedDeduction: 0,
    factoryNetWeight: 0,
    factoryNoOfBags: 0,
  });

  const [reportData, setReportData] = useState([]);

  const [messageModel, setMessageModel] = useState({
    hidden: true,
    type: "",
    disciption: "",
  });

  useEffect(() => {
    trackPromise(getPermissions(), getGroupsForDropdown());
  }, []);

  useEffect(() => {
    setReportData([]);
    trackPromise(getEstatesForDropdown());
  }, [divisionSummaryDetails.groupID]);

  useEffect(() => {
    setReportData([]);
    trackPromise(getDivisionsForDropDown());
  }, [divisionSummaryDetails.estateID]);

  useEffect(() => {
    setReportData([]);
    trackPromise(
      getFeildsByCollectionPoint(),
    )
  }, [divisionSummaryDetails.divisionID]);

  useEffect(() => { }, [reportData]);

  function handleGroupChange(target) {
    validateInputs(target);

    setDivisionSummaryDetails({
      ...divisionSummaryDetails,
      groupID: target.value,
      estateID: "0",
      fieldID: "0",
    });
  }

  function handleEstateChange(target) {
    validateInputs(target);
    setDivisionSummaryDetails({
      ...divisionSummaryDetails,
      estateID: target.value,
      fieldID: "0",
      divisionID: "0",
      categoryID: "0",
      searchDate: new Date().toISOString().split("T")[0],
    });
  }

  function handleDivisionChange(target) {
    validateInputs(target);
    setDivisionSummaryDetails({
      ...divisionSummaryDetails,
      divisionID: target.value,
      categoryID: "0",
      fieldID: "0",
      searchDate: new Date().toISOString().split("T")[0],
    });
  }

  function handleFieldChange(target) {
    setReportData([]);
    validateInputs(target);
    setDivisionSummaryDetails({
      ...divisionSummaryDetails,
      fieldID: target.value
    });
  }

  function handleCategoryChange(target) {
    setReportData([]);
    validateInputs(target);
    setDivisionSummaryDetails({
      ...divisionSummaryDetails,
      categoryID: target.value,
    });
  }

  function handleSearchDateChange(target) {
    setReportData([]);
    validateInputs(target);
    setDivisionSummaryDetails({
      ...divisionSummaryDetails,
      searchDate: target.value,
    });
  }

  function validateInputs(target) {
    const error = { ...errors };
    const errorMessage = validateProperty(
      target,
      DivisionSummaryReportSchemaObject
    );
    errorMessage
      ? (error[target.name] = errorMessage)
      : delete error[target.name];

    setErrors(error);
  }

  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);

    var isAuthorized = permissions.find(
      (p) => p.permissionCode == "VIEWDIVISIONSUMMARYREPORT"
    );

    if (isAuthorized === undefined) {
      props.history.push("/unauthorized");
    }

    var isGroupFilterEnabled = permissions.find(
      (p) => p.permissionCode == "GROUPDROPDOWN"
    );

    var isOperationEntityFilterEnabled = permissions.find(
      (p) => p.permissionCode == "OPERATIONENTITYDROPDOWN"
    );

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isOperationEntityFilterEnabled:
        isOperationEntityFilterEnabled !== undefined,
    });

    var token = tokenService.getUserDetailsFromTokenV2();

    if (token.operationEntities.length > 0) {
      var estateArray = [];
      for (let item of Object.entries(token.operationEntities)) {
        estateArray[item[1]["OperationEntityID"]] = item[1]["OperationEntityName"]
      }
      setMultipleEstates(estateArray)
    }

    setDivisionSummaryDetails({
      ...divisionSummaryDetails,
      groupID: token.groupID,
      estateID: token.operationEntityID,
    });

    trackPromise(getGroupsForDropdown());
  }

  async function getGroupsForDropdown() {
    const result = await services.getAlGroupsForDropdown();
    setGroups(result);
  }

  async function getEstatesForDropdown() {
    const data = await services.getEstatesByGroupID(
      divisionSummaryDetails.groupID
    );
    setEstates(data);
  }

  async function getDivisionsForDropDown() {
    const data = await services.getDivisionByEstateID(
      divisionSummaryDetails.estateID
    );
    setDivisions(data);
  }

  async function getFeildsByCollectionPoint() {
    const fields = await services.GetAvialableFieldsForDropdown(divisionSummaryDetails.divisionID);
    setFields(fields);
  }

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }

  async function handleSearch(e) {
    e.preventDefault();

    const errorMessages = validate(schema, divisionSummaryDetails);
    errorMessages !== null ? setErrors(errorMessages) : setErrors({});
    if (errorMessages) return;
    var copyOftotalCollections = totalCollections;
    var csvHeadersCopy = csvHeaders;
    for (const key in copyOftotalCollections) {
      copyOftotalCollections[key] = 0;
    }
    setTotalCollections(copyOftotalCollections);
    getSelectedDropdownValuesForReport(divisionSummaryDetails);
    const result = await services.getDivisionSummaryReportData(divisionSummaryDetails);
    var pluckingResult = result.pluckingResult;
    var factoryResult = result.factoryResult;
    var fieldResult = result.fieldResult;
    var deductions = result.deductions;

    var hasNoRecords =
      (!pluckingResult || pluckingResult.length === 0) &&
      (!factoryResult || factoryResult.length === 0) &&
      (!fieldResult || fieldResult.length === 0);

    if (hasNoRecords) {
      setReportData([]);
      destroyDataTable();
      setMessageModel({
        ...messageModel,
        hidden: false,
        type: "Warning",
        disciption: "No Records To Display",
      });
      setTimeout(() => {
        modalDismissHandler();
      }, 3000);
      return;
    }

    var joinedResult = [];
    var finalResult = [];
    var mergedPluckingResult = mergePluckingData(pluckingResult);
    var pluckingByField = _.keyBy(mergedPluckingResult, "fieldID");
    var fieldByFieldFactory = _.keyBy(fieldResult, (r) => `${r.fieldID}_${r.recievingFactory}`);

    if (factoryResult && factoryResult.length > 0) {
      factoryResult.forEach((factoryRow) => {
        var key = `${factoryRow.fieldID}_${factoryRow.recievingFactory}`;
        joinedResult.push({
          ...pluckingByField[factoryRow.fieldID],
          ...fieldByFieldFactory[key],
          ...factoryRow,
        });
      });

      var keysWithFactory = new Set(factoryResult.map((f) => `${f.fieldID}_${f.recievingFactory}`));
      Object.keys(fieldByFieldFactory).forEach((key) => {
        if (!keysWithFactory.has(key)) {
          var fRow = fieldByFieldFactory[key];
          joinedResult.push({
            ...pluckingByField[fRow.fieldID],
            ...fRow,
          });
        }
      });
    } else {
      Object.keys(fieldByFieldFactory).forEach((key) => {
        var fRow = fieldByFieldFactory[key];
        joinedResult.push({
          ...pluckingByField[fRow.fieldID],
          ...fRow,
        });
      });

      var fieldIdsWithGtn = new Set(fieldResult.map((f) => f.fieldID));
      Object.keys(pluckingByField).forEach((fid) => {
        if (!fieldIdsWithGtn.has(fid)) {
          joinedResult.push({ ...pluckingByField[fid] });
        }
      });
    }

    joinedResult.forEach((x) => {
      finalResult.push(x);
    });

    var rowNames = createDynmaicColumnNmaes(deductions, finalResult);

    var pluckingCountedForField = new Set();
    var pluckingDeductionCountedForField = {};

    console.log('totalCollections', totalCollections)

    finalResult.forEach((x) => {
      // Factory totals
      copyOftotalCollections.factoryOriginalWeight +=
        x.factoryOriginalWeight === undefined ? 0 : parseFloat(x.factoryOriginalWeight);
      copyOftotalCollections.factoryRoundDownDeduction +=
        x.factoryRoundDownDeduction === undefined ? 0 : parseFloat(x.factoryRoundDownDeduction);
      copyOftotalCollections.factoryGrossWeight +=
        x.factoryGrossWeight === undefined ? 0 : parseFloat(x.factoryGrossWeight);
      copyOftotalCollections.factoryAppliedDeduction +=
        x.factoryAppliedDeduction === undefined ? 0 : parseFloat(x.factoryAppliedDeduction);
      copyOftotalCollections.factoryNetWeight +=
        x.factoryNetWeight === undefined ? 0 : parseFloat(x.factoryNetWeight);
      copyOftotalCollections.factoryNoOfBags +=
        x.factoryNoOfBags === undefined ? 0 : parseInt(x.factoryNoOfBags);

      // Field totals
      copyOftotalCollections.fieldOriginalWeight +=
        x.fieldOriginalWeight === undefined ? 0 : parseFloat(x.fieldOriginalWeight);
      copyOftotalCollections.fieldRoundDownDeduction +=
        x.fieldRoundDownDeduction === undefined ? 0 : parseFloat(x.fieldRoundDownDeduction);
      copyOftotalCollections.fieldGrossWeight +=
        x.fieldGrossWeight === undefined ? 0 : parseFloat(x.fieldGrossWeight);
      copyOftotalCollections.fieldAppliedDeduction +=
        x.fieldAppliedDeduction === undefined ? 0 : parseFloat(x.fieldAppliedDeduction);
      copyOftotalCollections.fieldNetWeight +=
        x.fieldNetWeight === undefined ? 0 : parseFloat(x.fieldNetWeight);
      copyOftotalCollections.fieldNoOfBags +=
        x.fieldNoOfBags === undefined ? 0 : parseInt(x.fieldNoOfBags);

      var fieldKey = x.fieldID;
      var alreadyCountedPlucking = pluckingCountedForField.has(fieldKey);

      if (!alreadyCountedPlucking) {
        copyOftotalCollections.pluckingOriginalWeight +=
          x.pluckingOriginalWeight === undefined ? 0 : parseFloat(x.pluckingOriginalWeight);
        copyOftotalCollections.pluckingRoundDownDeduction +=
          x.pluckingRoundDownDeduction === undefined ? 0 : parseFloat(x.pluckingRoundDownDeduction);
        copyOftotalCollections.pluckingGrossWeight +=
          x.pluckingGrossWeight === undefined ? 0 : parseFloat(x.pluckingGrossWeight);
        copyOftotalCollections.pluckingAppliedDeduction +=
          x.pluckingAppliedDeduction === undefined ? 0 : parseFloat(x.pluckingAppliedDeduction);
        copyOftotalCollections.pluckingCheckrollWeight +=
          x.pluckingCheckrollWeight === undefined ? 0 : parseFloat(x.pluckingCheckrollWeight);
      }

      pluckingDeductions.forEach((y) => {
        if (!pluckingDeductionCountedForField[y]) pluckingDeductionCountedForField[y] = new Set();
        var alreadyCountedThisDeduction = pluckingDeductionCountedForField[y].has(fieldKey);

        if (copyOftotalCollections[y] === undefined) {
          copyOftotalCollections[y] = 0;
        }
        if (x[y] !== undefined && !alreadyCountedThisDeduction) {
          copyOftotalCollections[y] += x[y];
          pluckingDeductionCountedForField[y].add(fieldKey);
        }
      });

      if (fieldKey !== undefined) {
        pluckingCountedForField.add(fieldKey);
      }

      for (const key in x) {
        if (
          isNumber(x[key]) &&
          key !== "fieldNoOfBags" &&
          key !== "factoryNoOfBags"
        ) {
          x[key] = x[key];
        }
      }
    });

    pluckingDeductions.forEach((x, i) => {
      csvHeadersCopy.splice(7 + i, 0, { label: x, value: x });
    });

    for (const key in copyOftotalCollections) {
      if (key !== "fieldNoOfBags" && key !== "factoryNoOfBags") {
        copyOftotalCollections[key] = copyOftotalCollections[key];
      }
    }

    finalResult.sort((a, b) => {
      if (a.collectionPointID !== b.collectionPointID) {
        return a.collectionPointID > b.collectionPointID ? 1 : -1;
      }
      if (a.fieldID !== b.fieldID) {
        return a.fieldID > b.fieldID ? 1 : -1;
      }
      return 0;
    });
    divisionWiseData(finalResult);
    createCsvFile(finalResult, copyOftotalCollections);
    setTotalCollections(copyOftotalCollections);
    destroyDataTable();
    createDataTable(rowNames, ["#example3", "#pdfTable"]);
  }

  function normalizeNumericCell(value) {
    if (value === undefined) return '';
    if (typeof value === 'string' && (value === '' || value.includes('%') || value === '-')) {
      return value;
    }
    return parseFloat(value);
  }

  function createFile() {
    var settings = {
      sheetName: "Division Summary Report",
      fileName: "DivisionSummaryReport",
      writeOptions: {},
    };
    csvData.forEach((x) => {
      x.fieldGrossWeight = normalizeNumericCell(x.fieldGrossWeight);
      x.fieldNetWeight = normalizeNumericCell(x.fieldNetWeight);
      x.factoryGrossWeight = normalizeNumericCell(x.factoryGrossWeight);
    });
    var copyOfCsv = _.cloneDeep(csvData);
    var newRow1 = {
      collectionPointName: "Group : " + groups[divisionSummaryDetails.groupID],
      fieldName: "Estate : " + estates[divisionSummaryDetails.estateID],
      categoryText: divisionSummaryDetails.categoryID == 0 ? "Category : All" : divisionSummaryDetails.categoryID == 1 ? "Category : Outsource" : "Category : Revenue",
      pluckingGrossWeight: "Collection Point : " + (divisionSummaryDetails.divisionID == "0" ? "All" : selectedSearchValues.division),
      pluckingAppliedDeduction: "Field : " + (divisionSummaryDetails.fieldID == "0" ? "All" : selectedSearchValues.field),
      pluckingCheckrollWeight: "Search Date : " + divisionSummaryDetails.searchDate,
    };
    copyOfCsv.push({}, {}, newRow1);
    xlsx(csvHeaders, copyOfCsv, settings, true);
  }

  // Floors a numeric value (used to normalize weights before yield-ratio
  // percentage calculations below). Returns 0 for non-numeric/undefined input.
  function roundDown(value) {
    var n = parseFloat(value);
    if (!isFinite(n)) return 0;
    return Math.floor(n);
  }

  function safePercent(numerator, denominator) {
    var n = parseFloat(numerator);
    var d = parseFloat(denominator);
    if (!d || !isFinite(n) || !isFinite(d)) return "-";
    var pct = (n / d) * 100;
    return isFinite(pct) ? pct.toFixed(0) + "%" : "-";
  }

  function safePercentDiff(larger, smaller) {
    var l = parseFloat(larger);
    var s = parseFloat(smaller);
    if (!l || !isFinite(l) || !isFinite(s)) return "-";
    var pct = ((l - s) / l) * 100;
    return isFinite(pct) ? pct.toFixed(1) + "%" : "-";
  }

  function buildGainPercentageRow(total) {
    var row = {
      collectionPointName: "Gain percentages",
      fieldName: "",
      categoryText: "",
      pluckingGrossWeight: "",
      pluckingRoundDownDeduction: safePercent(total.pluckingRoundDownDeduction, total.pluckingGrossWeight),
      pluckingAppliedDeduction: safePercent(total.pluckingAppliedDeduction, total.pluckingGrossWeight),
      pluckingCheckrollWeight: safePercent(total.pluckingCheckrollWeight, total.pluckingGrossWeight),
      fieldGrossWeight: "",
      fieldRoundDownDeduction: safePercent(total.fieldRoundDownDeduction, total.fieldGrossWeight),
      fieldAppliedDeduction: safePercent(total.fieldAppliedDeduction, total.fieldGrossWeight),
      fieldNetWeight: safePercent(total.fieldNetWeight, total.fieldGrossWeight),
      fieldNoOfBags: "",
      recievingFactory: "",
      factoryOriginalWeight: "",
      factoryRoundDownDeduction: safePercent(total.factoryRoundDownDeduction, total.factoryGrossWeight),
      factoryGrossWeight: "",
      factoryAppliedDeduction: safePercent(total.factoryAppliedDeduction, total.factoryGrossWeight),
      factoryNetWeight: safePercent(total.factoryNetWeight, total.factoryGrossWeight),
      factoryNoOfBags: "",
    };
    pluckingDeductions.forEach((y) => {
      row[y] = "";
    });
    return row;
  }

  function buildLossRow(total) {
    var checkrollToFieldLoss = total.pluckingGrossWeight
      ? (((total.pluckingGrossWeight - total.fieldGrossWeight) / total.pluckingGrossWeight) * 100).toFixed(0) + "%"
      : "-";
    var fieldToFactoryLoss = total.fieldGrossWeight
      ? (((total.fieldGrossWeight - total.factoryGrossWeight) / total.fieldGrossWeight) * 100).toFixed(0) + "%"
      : "-";
    var row = {
      collectionPointName: "Checkroll to Field loss (O. Wt.)",
      fieldName: "",
      categoryText: "",
      pluckingGrossWeight: "",
      pluckingRoundDownDeduction: "",
      pluckingAppliedDeduction: "",
      pluckingCheckrollWeight: "",
      fieldGrossWeight: "",
      fieldAppliedDeduction: "",
      fieldRoundDownDeduction: "",
      fieldNetWeight: checkrollToFieldLoss,
      fieldNoOfBags: "",
      recievingFactory: "Field to Factory loss (O. Wt.)",
      factoryOriginalWeight: "",
      factoryRoundDownDeduction: "",
      factoryGrossWeight: "",
      factoryAppliedDeduction: "",
      factoryNetWeight: fieldToFactoryLoss,
      factoryNoOfBags: "",
    };
    pluckingDeductions.forEach((y) => {
      row[y] = "";
    });
    return row;
  }

  function buildYieldRatioRows(total) {
    var factoryCheckrollRow = {
      collectionPointName: "Factory/Checkroll",
      fieldName: "",
      categoryText: safePercentDiff(total.factoryNetWeight, total.pluckingCheckrollWeight),
      pluckingGrossWeight: "",
      pluckingRoundDownDeduction: "",
      pluckingAppliedDeduction: "",
      pluckingCheckrollWeight: "",
      fieldGrossWeight: "",
      fieldRoundDownDeduction: "",
      fieldAppliedDeduction: "",
      fieldNetWeight: "",
      fieldNoOfBags: "",
      recievingFactory: "",
      factoryOriginalWeight: "",
      factoryRoundDownDeduction: "",
      factoryGrossWeight: "",
      factoryAppliedDeduction: "",
      factoryNetWeight: "",
      factoryNoOfBags: "",
    };
    var fieldFactoryRow = {
      collectionPointName: "Field/Factory",
      fieldName: "",
      categoryText: safePercentDiff(total.fieldNetWeight, total.factoryNetWeight),
      pluckingGrossWeight: "",
      pluckingRoundDownDeduction: "",
      pluckingAppliedDeduction: "",
      pluckingCheckrollWeight: "",
      fieldGrossWeight: "",
      fieldRoundDownDeduction: "",
      fieldAppliedDeduction: "",
      fieldNetWeight: "",
      fieldNoOfBags: "",
      recievingFactory: "",
      factoryOriginalWeight: "",
      factoryRoundDownDeduction: "",
      factoryGrossWeight: "",
      factoryAppliedDeduction: "",
      factoryNetWeight: "",
      factoryNoOfBags: "",
    };
    var fieldCheckrollRow = {
      collectionPointName: "Field/Checkroll",
      fieldName: "",
      categoryText: safePercentDiff(total.fieldNetWeight, total.pluckingCheckrollWeight),
      pluckingGrossWeight: "",
      pluckingRoundDownDeduction: "",
      pluckingAppliedDeduction: "",
      pluckingCheckrollWeight: "",
      fieldGrossWeight: "",
      fieldRoundDownDeduction: "",
      fieldAppliedDeduction: "",
      fieldNetWeight: "",
      fieldNoOfBags: "",
      recievingFactory: "",
      factoryOriginalWeight: "",
      factoryRoundDownDeduction: "",
      factoryGrossWeight: "",
      factoryAppliedDeduction: "",
      factoryNetWeight: "",
      factoryNoOfBags: "",
    };
    [factoryCheckrollRow, fieldFactoryRow, fieldCheckrollRow].forEach((row) => {
      pluckingDeductions.forEach((y) => {
        row[y] = "";
      });
    });
    return [factoryCheckrollRow, fieldFactoryRow, fieldCheckrollRow];
  }

  function createCsvFile(data, total) {
    var res = [];
    var pluckingShownForField = new Set();

    data.forEach((x) => {
      var newrRecord = { ...x };
      if (x.isBold) {
        newrRecord.categoryText = "-";
      } else if (x.category === true) {
        newrRecord.categoryText = "Outsource";
      } else if (x.category === false) {
        newrRecord.categoryText = "Revenue";
      } else {
        newrRecord.categoryText = "-";
      }

      if (!x.isBold) {
        var fieldKey = x.fieldID;
        if (pluckingShownForField.has(fieldKey)) {
          newrRecord.pluckingOriginalWeight = "";
          newrRecord.pluckingRoundDownDeduction = "";
          newrRecord.pluckingGrossWeight = "";
          newrRecord.pluckingAppliedDeduction = "";
          newrRecord.pluckingCheckrollWeight = "";
          pluckingDeductions.forEach((y) => {
            newrRecord[y] = "";
          });
        } else {
          pluckingDeductions.forEach((y) => {
            newrRecord[y] = x[y];
          });
          if (fieldKey !== undefined) pluckingShownForField.add(fieldKey);
        }
      } else {
        pluckingDeductions.forEach((y) => {
          newrRecord[y] = x[y];
        });
      }

      res.push(newrRecord);
    });

    total.collectionPointName = "Total";
    total.categoryText = "-";
    var gainPercentageRow = buildGainPercentageRow(total);
    var lossRow = buildLossRow(total);
    var yieldRatioRows = buildYieldRatioRows(total);
    res.splice(data.length + 1, 0, total, gainPercentageRow, lossRow, {}, ...yieldRatioRows);
    setCsvData(res);
  }

  function createDynmaicColumnNmaes(deductions, finalResult) {
    var count = 3;
    var deductionsInReport = [];
    var rowNames = contentRowNames;

    deductions.forEach((x) => {
      finalResult.forEach((y) => {
        if (y[x.deductionTypeName] !== undefined) {
          if (!deductionsInReport.includes(x.deductionTypeName))
            deductionsInReport.push(x.deductionTypeName);
        }
      });
    });

    deductionsInReport.forEach((x) => {
      rowNames.splice(count, 0, x);
      count++;
    });

    setAvialablePluckingDeductions(deductionsInReport);
    availableDeductionCount = deductionsInReport.length;
    pluckingDeductions = deductionsInReport;
    return rowNames;
  }

  function mergePluckingData(pluckingResult) {
    var mergedPluckingResult = [];

    pluckingResult.forEach((x) => {
      var isPluckingDataExist = mergedPluckingResult.find(
        (y) => y.fieldID === x.fieldID
      );

      if (isPluckingDataExist) {
        isPluckingDataExist.pluckingOriginalWeight += x.pluckingOriginalWeight;
        isPluckingDataExist.pluckingCheckrollWeight +=
          x.pluckingCheckrollWeight;
        if (x.pluckingRoundDownDeduction !== undefined) {
          isPluckingDataExist.pluckingRoundDownDeduction =
            (isPluckingDataExist.pluckingRoundDownDeduction || 0) + x.pluckingRoundDownDeduction;
        }
        if (x.pluckingGrossWeight !== undefined) {
          isPluckingDataExist.pluckingGrossWeight =
            (isPluckingDataExist.pluckingGrossWeight || 0) + x.pluckingGrossWeight;
        }
        if (x.pluckingAppliedDeduction !== undefined) {
          isPluckingDataExist.pluckingAppliedDeduction =
            (isPluckingDataExist.pluckingAppliedDeduction || 0) + x.pluckingAppliedDeduction;
        }
        if (x.deductionTypeName !== null)
          isPluckingDataExist[x.deductionTypeName] = x.deductionAmount;
      } else {
        if (x.deductionTypeName !== null)
          x[x.deductionTypeName] = x.deductionAmount;

        delete x.deductionTypeName;
        delete x.deductionAmount;
        delete x.deductionTemplateID;
        mergedPluckingResult.push(x);
      }
    });

    return mergedPluckingResult;
  }

  function divisionWiseData(data) {
    var mergedPluckingResult = [];
    var pluckingCountedForDivision = {};

    data.forEach((x) => {
      var isExist = mergedPluckingResult.find(
        (y) => parseInt(y.collectionPointID) === parseInt(x.collectionPointID)
      );

      var cpKey = x.collectionPointID.toString();
      if (!pluckingCountedForDivision[cpKey]) pluckingCountedForDivision[cpKey] = new Set();
      var alreadyCountedField = pluckingCountedForDivision[cpKey].has(x.fieldID);

      if (isExist) {
        isExist.isBold = true;
        isExist.collectionPointID = x.collectionPointID.toString();
        isExist.collectionPointName = "Total for " + x.collectionPointName;

        if (!alreadyCountedField) {
          isExist.pluckingOriginalWeight +=
            x.pluckingOriginalWeight == undefined ? 0 : x.pluckingOriginalWeight;
          isExist.pluckingRoundDownDeduction +=
            x.pluckingRoundDownDeduction == undefined ? 0 : x.pluckingRoundDownDeduction;
          isExist.pluckingGrossWeight +=
            x.pluckingGrossWeight == undefined ? 0 : x.pluckingGrossWeight;
          isExist.pluckingAppliedDeduction +=
            x.pluckingAppliedDeduction == undefined ? 0 : x.pluckingAppliedDeduction;
          isExist.pluckingCheckrollWeight +=
            x.pluckingCheckrollWeight == undefined ? 0 : x.pluckingCheckrollWeight;
        }

        isExist.fieldOriginalWeight +=
          x.fieldOriginalWeight == undefined ? 0 : parseFloat(x.fieldOriginalWeight);
        isExist.fieldRoundDownDeduction +=
          x.fieldRoundDownDeduction == undefined ? 0 : parseFloat(x.fieldRoundDownDeduction);
        isExist.fieldGrossWeight +=
          x.fieldGrossWeight == undefined ? 0 : parseFloat(x.fieldGrossWeight);
        isExist.fieldAppliedDeduction +=
          x.fieldAppliedDeduction == undefined ? 0 : parseFloat(x.fieldAppliedDeduction);
        isExist.fieldNetWeight +=
          x.fieldNetWeight == undefined ? 0 : parseFloat(x.fieldNetWeight);
        isExist.fieldNoOfBags +=
          x.fieldNoOfBags == undefined ? 0 : parseInt(x.fieldNoOfBags);

        isExist.factoryOriginalWeight +=
          x.factoryOriginalWeight == undefined ? 0 : parseFloat(x.factoryOriginalWeight);
        isExist.factoryRoundDownDeduction +=
          x.factoryRoundDownDeduction == undefined ? 0 : parseFloat(x.factoryRoundDownDeduction);
        isExist.factoryGrossWeight +=
          x.factoryGrossWeight == undefined ? 0 : parseFloat(x.factoryGrossWeight);
        isExist.factoryAppliedDeduction +=
          x.factoryAppliedDeduction == undefined ? 0 : parseFloat(x.factoryAppliedDeduction);
        isExist.factoryNetWeight +=
          x.factoryNetWeight == undefined ? 0 : parseFloat(x.factoryNetWeight);
        isExist.factoryNoOfBags +=
          x.factoryNoOfBags == undefined ? 0 : parseInt(x.factoryNoOfBags);
        isExist.category = null;
      } else {
        mergedPluckingResult.push({
          isBold: true,
          collectionPointID: x.collectionPointID.toString(),
          collectionPointName: "Total for " + x.collectionPointName,

          pluckingOriginalWeight:
            x.pluckingOriginalWeight == undefined ? 0 : x.pluckingOriginalWeight,
          pluckingRoundDownDeduction:
            x.pluckingRoundDownDeduction == undefined ? 0 : x.pluckingRoundDownDeduction,
          pluckingGrossWeight:
            x.pluckingGrossWeight == undefined ? 0 : x.pluckingGrossWeight,
          pluckingAppliedDeduction:
            x.pluckingAppliedDeduction == undefined ? 0 : x.pluckingAppliedDeduction,
          pluckingCheckrollWeight:
            x.pluckingCheckrollWeight == undefined ? 0 : x.pluckingCheckrollWeight,

          fieldOriginalWeight:
            x.fieldOriginalWeight == undefined ? 0 : parseFloat(x.fieldOriginalWeight),
          fieldRoundDownDeduction:
            x.fieldRoundDownDeduction == undefined ? 0 : parseFloat(x.fieldRoundDownDeduction),
          fieldGrossWeight:
            x.fieldGrossWeight == undefined ? 0 : parseFloat(x.fieldGrossWeight),
          fieldAppliedDeduction:
            x.fieldAppliedDeduction == undefined ? 0 : parseFloat(x.fieldAppliedDeduction),
          fieldNetWeight: x.fieldNetWeight == undefined ? 0 : parseFloat(x.fieldNetWeight),
          fieldNoOfBags: x.fieldNoOfBags == undefined ? 0 : parseInt(x.fieldNoOfBags),

          factoryOriginalWeight:
            x.factoryOriginalWeight == undefined ? 0 : parseFloat(x.factoryOriginalWeight),
          factoryRoundDownDeduction:
            x.factoryRoundDownDeduction == undefined ? 0 : parseFloat(x.factoryRoundDownDeduction),
          factoryGrossWeight:
            x.factoryGrossWeight == undefined ? 0 : parseFloat(x.factoryGrossWeight),
          factoryAppliedDeduction:
            x.factoryAppliedDeduction == undefined ? 0 : parseFloat(x.factoryAppliedDeduction),
          factoryNetWeight:
            x.factoryNetWeight == undefined ? 0 : parseFloat(x.factoryNetWeight),
          factoryNoOfBags:
            x.factoryNoOfBags == undefined ? 0 : parseInt(x.factoryNoOfBags),
          category: null,
        });
      }

      pluckingCountedForDivision[cpKey].add(x.fieldID);
    });

    var result = arrayMerge(data, mergedPluckingResult);
    setReportData(result);
  }

  function arrayMerge(inputArray, totalDataArray) {
    let mainArray = [];
    for (const iterator of totalDataArray) {
      let tempArray = [...inputArray];
      let filteredArray = tempArray.filter(
        (e) =>
          e.collectionPointID.toString() ===
          iterator.collectionPointID.toString()
      );
      filteredArray.push(iterator);
      mainArray = mainArray.concat(filteredArray);
    }
    return mainArray;
  }

  function destroyDataTable() {
    $("#example3").DataTable().destroy();
  }

  function createDataTable(rowNames, dataTables) {
    dataTables.forEach((x) => {
      $(x)
        .DataTable({
          destroy: x === "#pdfTable" ? true : false,
          searching: x === "#pdfTable" ? false : true,
          paging: x === "#pdfTable" ? false : true,
          order: [[0, "asc"]],
          rowGroup: {
            startRender: null,
            endRender: function (rows, group) {
              var dynamicCountVariable = [];

              for (var i = 0; i < rowNames.length; ++i) {
                if (i !== 0 || i !== 1 || i !== 8 + availableDeductionCount) {
                  dynamicCountVariable[i] = rows
                    .data()
                    .pluck(i)
                    .reduce(function (a, b) {
                      return a + b * 1;
                    }, 0);
                } else {
                  dynamicCountVariable[i] = NaN;
                }
              }

              var rowData = "";

              for (var i = 0; i < rowNames.length; ++i) {
                if (isNaN(dynamicCountVariable[i])) {
                  if (i !== 0) rowData += "<td/>";
                } else {
                  rowData +=
                    '<td style="text-align:right"><b>' +
                    parseInt(dynamicCountVariable[i]) +
                    "</b></td>";
                }
              }

              return $("<tr/>")
                .append("<td><b>Total for " + group + "</b></td>")
                .append(rowData);
            },
            dataSrc: 0,
          },
        })
        .columns.adjust();
    });
  }

  function clearState() {
    setDivisionSummaryDetails({
      ...divisionSummaryDetails,
      divisionID: "0",
      fieldID: "0",
      searchDate: new Date().toISOString().split("T")[0],
      categoryID: "0",
    });
    setErrors("");
  }

  function getSelectedDropdownValuesForReport(searchForm) {
    setSelectedSearchValues({
      ...selectedSearchValues,
      group: groups[searchForm.groupID],
      estate: estates[searchForm.estateID],
      division: searchForm.divisionID == "0" ? "0" : divisions[searchForm.divisionID],
      field: searchForm.fieldID == "0" ? "0" : (fields ? fields[searchForm.fieldID] : "0"),
      categoryID: searchForm.categoryID,
      searchDate: searchForm.searchDate,
    });
  }

  function modalDismissHandler() {
    setMessageModel({ ...messageModel, hidden: true });
  }

  function computeYieldRatio(numerator, subtract) {
    if (!numerator) return { text: "-", color: undefined };
    var value = ((roundDown(numerator) - roundDown(subtract)) / roundDown(numerator)) * 100;
    if (!isFinite(value)) return { text: "-", color: undefined };
    var color = value < 0 ? "#d32f2f" : value > 0 ? "#2e7d32" : undefined;
    return { text: value.toFixed(0) + "%", color };
  }

  return (
    <Fragment>
      <LoadingSpinerComponent />
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <PageHeader
              title="Division Summary Report"
              isButtonEnable={permissionList.isAddEditEnabled}
            />
            <div className="card-body">
              <form onSubmit={(e) => handleSearch(e)} disabled={false}>
                <div className="form-group row">
                  <div className="col-md-4">
                    <InputLabel shrink id="groupID">
                      Group *
                    </InputLabel>
                    <Select
                      fullWidth
                      labelId="groupID"
                      id="groupID"
                      name="groupID"
                      value={divisionSummaryDetails.groupID}
                      disabled={!permissionList.isGroupFilterEnabled}
                      onChange={(e) => handleGroupChange(e.target)}
                    >
                      <MenuItem value="0">--Select Group--</MenuItem>
                      {generateDropDownMenu(groups)}
                    </Select>
                    {errors["groupID"] && (
                      <FormHelperText error>{errors["groupID"]}</FormHelperText>
                    )}
                  </div>
                  <div className="col-md-4">
                    <InputLabel shrink id="estateID">
                      Operation Entity *
                    </InputLabel>
                    <Select
                      fullWidth
                      labelId="estateID"
                      id="estateID"
                      name="estateID"
                      value={divisionSummaryDetails.estateID}
                      disabled={!permissionList.isOperationEntityFilterEnabled}
                      onChange={(e) => handleEstateChange(e.target)}
                    >
                      <MenuItem value="0">--Select Operation Entity--</MenuItem>
                      {generateDropDownMenu(
                        Object.fromEntries(
                          Object.entries(estates).filter(([key, value]) => {
                            if (key === "0" || !value) return false;
                            if (!multipleEstates || Object.keys(multipleEstates).length === 0) {
                              return true;
                            }
                            return Object.values(multipleEstates).includes(value);
                          })
                        )
                      )}
                    </Select>
                    {errors["estateID"] && (
                      <FormHelperText
                        id="errbranchCode"
                        className="text text-danger"
                      >
                        {errors["estateID"]}
                      </FormHelperText>
                    )}
                  </div>
                  <div className="col-md-4">
                    <InputLabel shrink id="">
                      Collection Point{" "}
                    </InputLabel>
                    <Select
                      fullWidth
                      labelId="divisionID"
                      id="divisionID"
                      name="divisionID"
                      value={divisionSummaryDetails.divisionID}
                      onChange={(e) => handleDivisionChange(e.target)}
                    >
                      <MenuItem value="0">--Select Collection Point--</MenuItem>
                      {generateDropDownMenu(divisions)}
                    </Select>
                    {errors["divisionID"] && (
                      <FormHelperText
                        id="errbranchCode"
                        className="text text-danger"
                      >
                        {errors["divisionID"]}
                      </FormHelperText>
                    )}
                  </div>
                  <div className="col-md-4">
                    <InputLabel shrink id="fieldID">Field</InputLabel>
                    <Select fullWidth
                      id="fieldID"
                      name="fieldID"
                      value={divisionSummaryDetails.fieldID}
                      onChange={(e) => handleFieldChange(e.target)}>
                      <MenuItem value="0">--All Field--</MenuItem>
                      {generateDropDownMenu(fields)}
                    </Select>
                    {errors["fieldID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["fieldID"]}</FormHelperText>}
                  </div>

                  <div className="col-md-4">
                    <InputLabel shrink id="categoryID">
                      Category
                    </InputLabel>
                    <Select fullWidth
                      id="categoryID"
                      name="categoryID"
                      value={divisionSummaryDetails.categoryID}
                      onChange={(e) => handleCategoryChange(e.target)}>
                      <MenuItem value="0">--Select Category--</MenuItem>
                      <MenuItem value="2">Revenue</MenuItem>
                      <MenuItem value="1">Outsource </MenuItem>
                    </Select>
                    {errors["categoryID"] && <FormHelperText id="errbranchCode" className="text text-danger"> {errors["categoryID"]} </FormHelperText>}
                  </div>

                  <div className="col-md-4">
                    <InputLabel shrink id="searchDate">
                      Search Date *
                    </InputLabel>
                    <TextField
                      fullWidth
                      id="searchDate"
                      name="searchDate"
                      type="date"
                      onChange={(e) => handleSearchDateChange(e.target)}
                      value={divisionSummaryDetails.searchDate}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    {errors["searchDate"] && (
                      <FormHelperText
                        id="errbranchCode"
                        className="text text-danger"
                      >
                        {errors["searchDate"]}
                      </FormHelperText>
                    )}
                  </div>
                </div>
                <div className="card-footer">
                  <input
                    disabled={validate(schema, divisionSummaryDetails)}
                    type="button"
                    className="btn btn-primary"
                    value="Search"
                    onClick={(e) => trackPromise(handleSearch(e))}
                  />

                  <input
                    type="reset"
                    className="btn btn-warning pull-right"
                    value="Clear"
                    onClick={clearState}
                  />
                </div>
              </form>

              {reportData.length != 0 ? (
                <div>
                  <div className="row">
                    <div className="row mt-3 mb-3 ml-2">
                      {[
                        {
                          label: "Factory / Checkroll",
                          ratio: computeYieldRatio(
                            totalCollections.factoryNetWeight,
                            totalCollections.pluckingCheckrollWeight
                          ),
                        },
                        {
                          label: "Field / Factory",
                          ratio: computeYieldRatio(
                            totalCollections.fieldNetWeight,
                            totalCollections.factoryNetWeight
                          ),
                        },
                        {
                          label: "Field / Checkroll",
                          ratio: computeYieldRatio(
                            totalCollections.fieldNetWeight,
                            totalCollections.pluckingCheckrollWeight
                          ),
                        },
                      ].map((row, i) => (
                        <div className="col-12 col-md-4 mb-3" key={i}>
                          <div
                            style={{
                              border: "1px solid #e0e0e0",
                              borderRadius: "8px",
                              padding: "15px 30px",
                              height: "100%",
                              backgroundColor: "#fff",
                              boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <div>
                              <div
                                style={{
                                  fontSize: "14px",
                                  color: "#666",
                                  fontWeight: 500,
                                  marginBottom: "5px",
                                }}
                              >
                                Yield Ratio
                              </div>

                              <div
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "bold",
                                  color: "#333",
                                }}
                              >
                                {row.label}
                              </div>
                            </div>

                            <div
                              style={{
                                fontSize: "22px",
                                fontWeight: "bold",
                                color: row.ratio.color || "#555",
                              }}
                            >
                              {row.ratio.text}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className="col-md-12">
                      <div>
                        <Table
                          id="divisionSummaryReportTable"
                          aria-label="simple table"
                          style={{ display: "block", overflowX: "auto", whiteSpace: "nowrap", maxWidth: "1600px", borderColor: "white" }}
                        >
                          <TableHead>
                            <TableRow>
                              <TableCell rowSpan="2" align="center" style={{ fontWeight: "bold" }}>
                                Division
                              </TableCell>
                              <TableCell rowSpan="2" align="center" style={{ fontWeight: "bold" }}>
                                Field
                              </TableCell>
                              <TableCell rowSpan="2" align="center" style={{ fontWeight: "bold" }}>Category</TableCell>
                              <TableCell
                                align="center"
                                colSpan={4 + avialablePluckingDeductions.length}
                                style={{ background: "lightblue", fontWeight: "bold" }}
                              >
                                Plucker collection
                              </TableCell>
                              <TableCell
                                align="center"
                                colSpan="5"
                                style={{ background: "lightgreen", fontWeight: "bold" }}
                              >
                                Field collection
                              </TableCell>
                              <TableCell
                                align="center"
                                colSpan="7"
                                style={{ background: "lightyellow", fontWeight: "bold" }}
                              >
                                Factory collection
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              {/* PLUCKING (Original Weight removed) */}
                              <TableCell align="center" style={{ fontWeight: "bold" }}>Gross Weight</TableCell>
                              <TableCell align="center" style={{ fontWeight: "bold" }}>Applied Deduction</TableCell>
                              <TableCell align="center" style={{ fontWeight: "bold" }}>Round Down Deduction</TableCell>
                              <TableCell align="center" style={{ fontWeight: "bold" }}>Checkroll Weight</TableCell>

                              {avialablePluckingDeductions.map((x, index) => (
                                <TableCell
                                  align="center"
                                  style={{ wordWrap: "break-word", fontWeight: "bold" }}
                                  key={index}
                                >
                                  {x}
                                </TableCell>
                              ))}

                              {/* FIELD (Original Weight removed) */}
                              <TableCell align="center" style={{ fontWeight: "bold" }}>Gross Weight</TableCell>
                              <TableCell align="center" style={{ fontWeight: "bold" }}>Applied Deduction</TableCell>
                              <TableCell align="center" style={{ fontWeight: "bold" }}>Round Down Deduction</TableCell>
                              <TableCell align="center" style={{ fontWeight: "bold" }}>Net Weight</TableCell>
                              <TableCell align="center" style={{ fontWeight: "bold" }}>No Of Bags</TableCell>

                              {/* FACTORY (unchanged) */}
                              <TableCell align="center" style={{ fontWeight: "bold" }}>Receiving Factory</TableCell>
                              <TableCell align="center" style={{ fontWeight: "bold" }}>Original Weight</TableCell>
                              <TableCell align="center" style={{ fontWeight: "bold" }}>Round Down Deduction</TableCell>
                              <TableCell align="center" style={{ fontWeight: "bold" }}>Gross Weight</TableCell>
                              <TableCell align="center" style={{ fontWeight: "bold" }}>Applied Deduction</TableCell>
                              <TableCell align="center" style={{ fontWeight: "bold" }}>Net Weight</TableCell>
                              <TableCell align="center" style={{ fontWeight: "bold" }}>No Of Bags</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {(() => {
                              var rowSpanCounts = {};
                              reportData.forEach((row) => {
                                if (row.isBold) return;
                                var key = `${row.collectionPointID}_${row.fieldID}`;
                                rowSpanCounts[key] = (rowSpanCounts[key] || 0) + 1;
                              });

                              var renderedGroups = new Set();

                              return reportData.map((row, idx) => {
                                var groupKey = row.isBold ? null : `${row.collectionPointID}_${row.fieldID}`;
                                var isFirstOfGroup = groupKey ? !renderedGroups.has(groupKey) : true;
                                if (groupKey) renderedGroups.add(groupKey);
                                var span = groupKey ? rowSpanCounts[groupKey] : 1;
                                var boldStyle = { fontWeight: row.isBold == undefined ? null : "bold" };

                                return (
                                  <TableRow key={idx}>
                                    {isFirstOfGroup && (
                                      <TableCell rowSpan={span} component="th" scope="row" style={boldStyle}>
                                        {row.collectionPointName == undefined ? "-" : row.collectionPointName}
                                      </TableCell>
                                    )}
                                    {isFirstOfGroup && (
                                      <TableCell rowSpan={span} component="th" scope="row" style={boldStyle}>
                                        {row.fieldName == undefined ? "-" : row.fieldName}
                                      </TableCell>
                                    )}
                                    {isFirstOfGroup && (
                                      <TableCell rowSpan={span} component="th" scope="row" style={boldStyle}>
                                        {row.isBold ? "-" : row.category === true ? "Outsource" : row.category === false ? "Revenue" : "-"}
                                      </TableCell>
                                    )}

                                    {isFirstOfGroup && (
                                      <TableCell rowSpan={span} component="th" align="right" scope="row" style={boldStyle}>
                                        {row.pluckingGrossWeight == undefined ? "-" : parseFloat(row.pluckingGrossWeight).toFixed(2)}
                                      </TableCell>
                                    )}
                                    {isFirstOfGroup && (
                                      <TableCell rowSpan={span} component="th" align="right" scope="row" style={boldStyle}>
                                        {row.pluckingAppliedDeduction == undefined ? "-" : parseFloat(row.pluckingAppliedDeduction).toFixed(2)}
                                      </TableCell>
                                    )}
                                    {isFirstOfGroup && (
                                      <TableCell rowSpan={span} component="th" align="right" scope="row" style={boldStyle}>
                                        {row.pluckingRoundDownDeduction == undefined ? "-" : parseFloat(row.pluckingRoundDownDeduction).toFixed(2)}
                                      </TableCell>
                                    )}
                                    {isFirstOfGroup && (
                                      <TableCell rowSpan={span} component="th" align="right" scope="row" style={boldStyle}>
                                        {row.pluckingCheckrollWeight == undefined ? "-" : parseFloat(row.pluckingCheckrollWeight).toFixed(2)}
                                      </TableCell>
                                    )}

                                    {isFirstOfGroup && avialablePluckingDeductions.map((d, i) => (
                                      <TableCell rowSpan={span} key={i} align="right" style={boldStyle}>
                                        {row[d] == undefined ? "-" : parseFloat(row[d]).toFixed(2)}
                                      </TableCell>
                                    ))}

                                    <TableCell component="th" align="right" scope="row" style={boldStyle}>
                                      {row.fieldGrossWeight == undefined ? "-" : parseFloat(row.fieldGrossWeight).toFixed(2)}
                                    </TableCell>
                                    <TableCell component="th" align="right" scope="row" style={boldStyle}>
                                      {row.fieldAppliedDeduction == undefined ? "-" : parseFloat(row.fieldAppliedDeduction).toFixed(2)}
                                    </TableCell>
                                    <TableCell component="th" align="right" scope="row" style={boldStyle}>
                                      {row.fieldRoundDownDeduction == undefined ? "-" : parseFloat(row.fieldRoundDownDeduction).toFixed(2)}
                                    </TableCell>
                                    <TableCell component="th" align="right" scope="row" style={boldStyle}>
                                      {row.fieldNetWeight == undefined ? "-" : row.isBold ? parseInt(row.fieldNetWeight) : parseFloat(row.fieldNetWeight).toFixed(2)}
                                    </TableCell>
                                    <TableCell component="th" align="right" scope="row" style={boldStyle}>
                                      {row.fieldNoOfBags == undefined ? "-" : row.fieldNoOfBags}
                                    </TableCell>

                                    <TableCell component="th" scope="row" style={boldStyle}>
                                      {row.recievingFactory == undefined ? "-" : row.recievingFactory}
                                    </TableCell>
                                    <TableCell component="th" align="right" scope="row" style={boldStyle}>
                                      {row.factoryOriginalWeight == undefined ? "-" : parseFloat(row.factoryOriginalWeight).toFixed(2)}
                                    </TableCell>
                                    <TableCell component="th" align="right" scope="row" style={boldStyle}>
                                      {row.factoryRoundDownDeduction == undefined ? "-" : parseFloat(row.factoryRoundDownDeduction).toFixed(2)}
                                    </TableCell>
                                    <TableCell component="th" align="right" scope="row" style={boldStyle}>
                                      {row.factoryGrossWeight == undefined ? "-" : parseFloat(row.factoryGrossWeight).toFixed(2)}
                                    </TableCell>
                                    <TableCell component="th" align="right" scope="row" style={boldStyle}>
                                      {row.factoryAppliedDeduction == undefined ? "-" : parseFloat(row.factoryAppliedDeduction).toFixed(2)}
                                    </TableCell>
                                    <TableCell component="th" align="right" scope="row" style={boldStyle}>
                                      {row.factoryNetWeight == undefined ? "-" : row.isBold ? parseInt(row.factoryNetWeight) : parseFloat(row.factoryNetWeight).toFixed(2)}
                                    </TableCell>
                                    <TableCell component="th" align="right" scope="row" style={boldStyle}>
                                      {row.factoryNoOfBags == undefined ? "-" : row.factoryNoOfBags}
                                    </TableCell>
                                  </TableRow>
                                );
                              });
                            })()}
                          </TableBody>
                          <TableHead>
                            <TableRow>
                              <TableCell colSpan="3" align="center" style={{ fontWeight: "bold" }}>
                                Total
                              </TableCell>

                              <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}>
                                {parseFloat(totalCollections.pluckingGrossWeight).toFixed(2)}
                              </TableCell>
                              <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}>
                                {parseFloat(totalCollections.pluckingAppliedDeduction).toFixed(2)}
                              </TableCell>
                              <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}>
                                {parseFloat(totalCollections.pluckingRoundDownDeduction).toFixed(2)}
                              </TableCell>
                              <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}>
                                {parseFloat(totalCollections.pluckingCheckrollWeight).toFixed(2)}
                              </TableCell>

                              {avialablePluckingDeductions.map((x, i) => (
                                <TableCell key={i} component="th" scope="row" align="right" style={{ fontWeight: "bold" }}>
                                  {parseFloat(totalCollections[x] || 0).toFixed(2)}
                                </TableCell>
                              ))}

                              <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}>
                                {parseFloat(totalCollections.fieldGrossWeight).toFixed(2)}
                              </TableCell>
                              <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}>
                                {parseFloat(totalCollections.fieldAppliedDeduction).toFixed(2)}
                              </TableCell>
                              <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}>
                                {parseFloat(totalCollections.fieldRoundDownDeduction).toFixed(2)}
                              </TableCell>
                              <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}>
                                {parseInt(totalCollections.fieldNetWeight)}
                              </TableCell>
                              <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}>
                                {totalCollections.fieldNoOfBags}
                              </TableCell>

                              <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}> </TableCell>
                              <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}>
                                {parseFloat(totalCollections.factoryOriginalWeight).toFixed(2)}
                              </TableCell>
                              <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}>
                                {parseFloat(totalCollections.factoryRoundDownDeduction).toFixed(2)}
                              </TableCell>
                              <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}>
                                {parseFloat(totalCollections.factoryGrossWeight).toFixed(2)}
                              </TableCell>
                              <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}>
                                {parseFloat(totalCollections.factoryAppliedDeduction).toFixed(2)}
                              </TableCell>
                              <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}>
                                {parseInt(totalCollections.factoryNetWeight)}
                              </TableCell>
                              <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}>
                                {totalCollections.factoryNoOfBags}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell rowSpan="2" colSpan="3" align="center" style={{ fontWeight: "bold" }}>
                                Gain percentages
                              </TableCell>

                              <TableCell></TableCell>
                              <TableCell align="right" style={{ fontWeight: "bold" }}>
                                {totalCollections.pluckingGrossWeight
                                  ? ((totalCollections.pluckingAppliedDeduction / totalCollections.pluckingGrossWeight) * 100).toFixed(0) + "%"
                                  : "-"}
                              </TableCell>
                              <TableCell align="right" style={{ fontWeight: "bold" }}>
                                {totalCollections.pluckingGrossWeight
                                  ? ((totalCollections.pluckingRoundDownDeduction / totalCollections.pluckingGrossWeight) * 100).toFixed(0) + "%"
                                  : "-"}
                              </TableCell>
                              <TableCell align="right" style={{ fontWeight: "bold" }}>
                                {totalCollections.pluckingGrossWeight
                                  ? ((totalCollections.pluckingCheckrollWeight / totalCollections.pluckingGrossWeight) * 100).toFixed(0) + "%"
                                  : "-"}
                              </TableCell>

                              {avialablePluckingDeductions.map((x, i) => (
                                <TableCell key={i}></TableCell>
                              ))}

                              <TableCell></TableCell>
                              <TableCell align="right" style={{ fontWeight: "bold" }}>
                                {totalCollections.fieldGrossWeight
                                  ? ((totalCollections.fieldAppliedDeduction / totalCollections.fieldGrossWeight) * 100).toFixed(0) + "%"
                                  : "-"}
                              </TableCell>
                              <TableCell align="right" style={{ fontWeight: "bold" }}>
                                {totalCollections.fieldGrossWeight
                                  ? ((totalCollections.fieldRoundDownDeduction / totalCollections.fieldGrossWeight) * 100).toFixed(0) + "%"
                                  : "-"}
                              </TableCell>
                              <TableCell align="right" style={{ fontWeight: "bold" }}>
                                {totalCollections.fieldGrossWeight
                                  ? ((totalCollections.fieldNetWeight / totalCollections.fieldGrossWeight) * 100).toFixed(0) + "%"
                                  : "-"}
                              </TableCell>
                              <TableCell></TableCell>

                              <TableCell></TableCell>
                              <TableCell></TableCell>
                              <TableCell align="right" style={{ fontWeight: "bold" }}>
                                {totalCollections.factoryOriginalWeight
                                  ? ((totalCollections.factoryRoundDownDeduction / totalCollections.factoryOriginalWeight) * 100).toFixed(0) + "%"
                                  : "-"}
                              </TableCell>
                              <TableCell></TableCell>
                              <TableCell align="right" style={{ fontWeight: "bold" }}>
                                {totalCollections.factoryOriginalWeight
                                  ? ((totalCollections.factoryAppliedDeduction / totalCollections.factoryOriginalWeight) * 100).toFixed(0) + "%"
                                  : "-"}
                              </TableCell>
                              <TableCell align="right" style={{ fontWeight: "bold" }}>
                                {totalCollections.factoryOriginalWeight
                                  ? ((totalCollections.factoryNetWeight / totalCollections.factoryOriginalWeight) * 100).toFixed(0) + "%"
                                  : "-"}
                              </TableCell>
                              <TableCell></TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell colSpan={4 + avialablePluckingDeductions.length}></TableCell>

                              <TableCell colSpan="3" align="center" style={{ fontWeight: "bold" }}>
                                Checkroll to Field loss (O. Wt.)
                              </TableCell>
                              <TableCell align="right" style={{ fontWeight: "bold" }}>
                                {totalCollections.fieldOriginalWeight
                                  ? ((totalCollections.pluckingGrossWeight - totalCollections.fieldGrossWeight) / totalCollections.pluckingGrossWeight * 100).toFixed(0) + "%"
                                  : "-"}
                              </TableCell>
                              <TableCell></TableCell>

                              <TableCell colSpan="5" align="center" style={{ fontWeight: "bold" }}>
                                Field to Factory loss (O. Wt.)
                              </TableCell>
                              <TableCell align="right" style={{ fontWeight: "bold" }}>
                                {totalCollections.factoryOriginalWeight
                                  ? ((totalCollections.fieldGrossWeight - totalCollections.factoryGrossWeight) / totalCollections.fieldGrossWeight * 100).toFixed(0) + "%"
                                  : "-"}
                              </TableCell>
                              <TableCell></TableCell>
                            </TableRow>
                          </TableHead>
                        </Table>
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
            {reportData.length != 0 ? (
              <div className="pt-2">
                <ReactToPrint
                  trigger={() => (
                    <input
                      type="button"
                      className="btn btn-primary pull-right ml-2"
                      value="PDF"
                    />
                  )}
                  content={() => componentRef.current}
                />
                <div hidden={true}>
                  <CreatePdf
                    ref={componentRef}
                    avialablePluckingDeductions={avialablePluckingDeductions}
                    reportData={reportData}
                    totalCollections={totalCollections}
                    searchData={selectedSearchValues}
                  />
                </div>{" "}
                <input
                  type="button"
                  className="btn btn-primary pull-right ml-2"
                  value="Excel"
                  onClick={createFile}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <MessageModal
        hidden={messageModel.hidden}
        messageType={messageModel.type}
        messageDescription={messageModel.disciption}
        clicked={modalDismissHandler}
      />
    </Fragment>
  );
}